<template>
  <div class="l-wrap">
    <h1 class="logo">
      <img src="../assets/images/logo.png" alt="DGB대구은행" />
    </h1>
    <section class="index-section">
      <h2>로그인</h2>
      <p class="sub-txt">가맹점주님 환영합니다.</p>
      <div class="input-wrap">
        <div class="id-area">
          <label>
            아이디
            <input type="text" name="id" placeholder="아이디를 입력하세요." autocomplete="off" />
          </label>
        </div>
        <div class="pw-area">
          <label>
            비밀번호
            <input type="password" name="pw" placeholder="비밀번호를 입력하세요." autocomplete="off" />
          </label>
        </div>
        <div class="btn-save-id">
          <input id="saveId" type="checkbox" />
          <label for="saveId" @click="checked = !checked" :class="{'is-checked': checked}">
            <span class="check-img"></span>
            <span class="label">아이디 저장</span>
          </label>
        </div>
      </div>
    </section>
    <p class="validation-msg">아이디/비밀번호가 일치하지 않습니다.</p>
    <router-link to="/main">
    <div class="btn btn-blue">
      <span>로그인</span>
    </div>
    </router-link>
    <div class="btn btn-gray">
      <span>취소</span>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Login',
  data () {
    return {
      checked: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue